import API from "./index";
import moment from "moment";

class ExercicioFiscalService {
  constructor() {
    this.path = "/api/exercicio-fiscal";
  }

  createExercicioFiscal(createIntent) {
    return API.post(this.path, createIntent);
  }

  updateExercicioFiscal(id, updateIntent) {
    return API.put(`${this.path}/${id}`, updateIntent);
  }

  getById(id) {
    return API.get(`${this.path}/${id}`);
  }

  listExercicioFiscal(parameters) {
    return API.get(this.path, { params: parameters });
  }

  alterarStatus(id) {
    return API.put(`${this.path}/${id}/alterar-status`);
  }

  ativarDesativar(id) {
    return API.put(`${this.path}/${id}/ativar-desativar`);
  }

  getExercicioFiscalVigente(codStatus, dataAtual) {
    const formattedDate = moment(dataAtual || new Date()).format("YYYY-MM-DDTHH:mm:ss");
    return API.get(`${this.path}/vigente`, {
      params: {
        codStatus,
        dataAtual: formattedDate
      }
    });
  }
}

export default ExercicioFiscalService;
